import React from "react";
import { Plus, Trash2 } from "lucide-react";
import { Field, TextInput, Toggle } from "../shared";

export const ShippingPanel = ({ settings, setSettings }) => {
  const methods = settings.shipping_methods || [];
  const setMethod = (id, patch) =>
    setSettings({ ...settings, shipping_methods: methods.map((m) => (m.id === id ? { ...m, ...patch } : m)) });

  return (
    <div className="bg-warmwhite border border-plum-deep/10 rounded-[1.5rem] p-6 mb-8" data-testid="shipping-panel">
      <h2 className="font-serif-display uppercase text-plum-deep text-xl mb-2">SHIPPING</h2>
      <p className="text-xs text-plum-deep/60 mb-5">Create your own shipping options — customers choose from active options at checkout. Add a $0 option to offer free shipping.</p>
      <div className="space-y-3">
        {methods.map((m) => (
          <div key={m.id} className="flex items-center gap-3 bg-cream rounded-2xl p-3 flex-wrap" data-testid={`shipping-method-row-${m.id}`}>
            <TextInput value={m.name} onChange={(e) => setMethod(m.id, { name: e.target.value })} className="flex-1 min-w-[160px]" data-testid={`shipping-name-${m.id}`} />
            <div className="flex items-center gap-1">
              <span className="text-xs text-plum-deep/50">$</span>
              <TextInput type="number" step="0.5" value={m.price} onChange={(e) => setMethod(m.id, { price: e.target.value })} className="w-24 !px-3" data-testid={`shipping-price-${m.id}`} />
            </div>
            <Toggle checked={m.active} onChange={() => setMethod(m.id, { active: !m.active })} testid={`shipping-toggle-${m.id}`} />
            <button
              onClick={() => setSettings({ ...settings, shipping_methods: methods.filter((x) => x.id !== m.id) })}
              className="text-plum-deep/40 hover:text-red-600" data-testid={`shipping-delete-${m.id}`} aria-label="Delete shipping option"
            >
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
      <div className="mt-4 flex flex-wrap items-end gap-4">
        <button
          onClick={() => setSettings({ ...settings, shipping_methods: [...methods, { id: crypto.randomUUID(), name: "NEW SHIPPING OPTION", price: 0, active: true }] })}
          className="inline-flex items-center gap-2 rounded-full bg-plum text-cream px-4 py-2.5 text-xs uppercase tracking-[0.14em] font-semibold hover:bg-magenta"
          data-testid="add-shipping-method"
        >
          <Plus className="w-3.5 h-3.5" /> ADD SHIPPING OPTION
        </button>
        <div className="w-56">
          <Field label="FREE SHIPPING OVER (NZD, 0 = NEVER)">
            <TextInput type="number" step="1" value={settings.shipping_free_over ?? ""} onChange={(e) => setSettings({ ...settings, shipping_free_over: e.target.value })} data-testid="setting-shipping-free-over" />
          </Field>
        </div>
        <p className="text-[11px] text-plum-deep/50">Remember to SAVE SETTINGS above to apply shipping changes.</p>
      </div>
    </div>
  );
};
